// extracted by mini-css-extract-plugin
export default {"upcomingEvents":"upcomingEvents_upcomingEvents__SRtHX","globalUnknonwn":"upcomingEvents_globalUnknonwn__IcOst"};